import { jwtDecode } from 'jwt-decode';

type Jwt = { email?: string };

export function getEmailFromToken(token: string | undefined) {
  if (!token) {
    return;
  }

  const decoded = jwtDecode<Jwt>(token);
  return decoded.email;
}
